export default __webpack_public_path__ + "static/media/Theme4.6e1aa6dd.jpg";